import ApiService from "@/utils/request"

export const messageServe = {
  list(id, params) {
    return ApiService.query(`alumni/message/session/page/${id}/`, params)
  },
  createChat(params) {
    return ApiService.post(`alumni/message/session/`, params)
  },
  sendToId(fromId, toId, params) {
    return ApiService.post(`alumni/message/send/${fromId}/${toId}/`, params)
  },
  history(id, params) {
    return ApiService.query(`alumni/message/session/${id}/history`, params)
  },
  setRead(params) {
    return ApiService.post(
      `alumni/message/read/?alumniId=${params.alumniId}&messageId=${params.messageId}`
    )
  }
}

export const inviteServe = {
  createUrl(id) {
    return ApiService.post(`alumni/invitation/?id=${id}`)
  },
  accept(params) {
    return ApiService.post(`alumni/invitation/accept/`, params)
  }
}
